<template>
  <div id="v-card-widget">
    <v-card outlined>
      <v-toolbar
        v-if="enableHeader"
        color="transparent"
        dense
        flat
        class="toolbar-title"
      >
        <v-toolbar-title>
          <h4>
            {{ title }}
          </h4>
        </v-toolbar-title>
      </v-toolbar>

      <v-divider v-if="enableHeader" />

      <v-card-text>
        <slot name="widget-content" />
      </v-card-text>

      <v-divider v-if="enableActions" />

      <v-card-actions v-if="enableActions">
        <v-spacer />
        <slot name="widget-actions" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'VCardWidget',

  props: {
    title: {
      type: String,
      default: '',
    },
    goBack: {
      type: String,
      default: '',
    },
    enableHeader: {
      type: Boolean,
      default: true,
    },
    contentBg: {
      type: String,
      default: 'white',
    },
    enableActions: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.toolbar-title h4 {
  font-weight: 300;
}
.v-card__text {
  font-size: 1rem !important;
}
</style>
